export default __webpack_public_path__ + "1.19.2/static/media/no-practices.8a6fd274.svg";